import {HttpConfig, HttpResponse} from "@/Fwk/Http/HttpConfig";
import RequestMgr from "@/Fwk/Http/RequestMgr";
import {comRequest} from "@/Fwk/Http/comRequest";
import Util from "@/Master/Util";
import {getToken, getUserId, getUuidChange, setUuidChange} from "@/app/utils/auth";
import DataMgr from "@/Fwk/DataMgr";
import {NetType} from "@/Fwk/Http/NetType";

type SyncUnityGameDataResponse = {
    userId: number;//用户id
}

type SyncUnityGameDataRequest = {
    data:string;    //	加密数据
    userId:number;   //	用户ID
    uuid:string;    //	用户设备ID
}

export default class UnityGameDataManager
{
    public static Instance = new UnityGameDataManager();
    private isRequesting: boolean = false;
    private static SP_NAME = "_Drive.CacheSyncData";
    static TAG = "UnityGame";

    constructor()
    {
        // EventManager.addEventListener(masterEvent.onVisibilitychangeHide,()=>{
        //     // UnityGameDataManager.HandleUnityGameData(getUserId());
        // });
    }

    private async DoSendRequest<T>(config: HttpConfig): Promise<HttpResponse<T>> {
        this.isRequesting = true;
        config.isSerErrTips = true;
        const sendRequest = await comRequest<T>(config);
        this.isRequesting = false;
        return sendRequest;
    }

    // 发送注册请求
    private async SyncUnityGameData(data: SyncUnityGameDataRequest, onFinish: (res: HttpResponse<SyncUnityGameDataResponse>) => void){
        if (this.isRequesting) return false;
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.TransUnityGameData),
            method: 'POST',
            body: data,
        };
        const response = await this.DoSendRequest<SyncUnityGameDataResponse>(config);
        onFinish(response);
        return true;
    }

    public static async HandleUnityGameData(onFinish:()=>void = ()=>{})
    {
        let uuidChange = getUuidChange();
        let userId = getUserId();
        let dataId = userId + this.SP_NAME;
        if (uuidChange)
        {
            setUuidChange(false);
            //清除数据
            DataMgr.setStorage(dataId, "");
            //
            onFinish();
        }
        else
        {

            let data = DataMgr.getStorage(dataId);
            if (data != null && data.length > 0)
            {
                if (Util.isLog) console.log(this.TAG,'UnityGameData数据：',data);
                let sendData = {} as SyncUnityGameDataRequest;
                sendData.uuid = Util.h5UUID;
                sendData.data = data;
                sendData.userId = userId;
                await UnityGameDataManager.Instance.SyncUnityGameData(sendData, (res: HttpResponse<SyncUnityGameDataResponse>) => {
                    if (res){
                        if (Util.isLog) console.log(this.TAG,'传送UnityGameData成功',res);
                        //
                        if (res.code == 200)
                        {
                            //清除数据
                            DataMgr.setStorage(dataId, "");
                            //
                            onFinish();
                        }
                    }else{
                        if (Util.isLog) console.error(this.TAG,'传送UnityGameData报错');
                    }
                });
            }
            else {
                onFinish();
            }
        }
    }
}